import AddShoppingCart from '@mui/icons-material/AddShoppingCart';
import Check from '@mui/icons-material/Check';

import { MediaIconButton } from '@/components/atoms';
import { useCarOrderEntry } from '@/hooks/useCarOrderEntry';
import { type VehicleListing } from '@/services/vehicles/types';
import { vehicleTitle } from '@/utils/vehicleFormat';

/**
 * Icon-only cart toggle for a photograph, so a car can be added from the grid
 * without opening it. Pressed (filled with a check) once in the cart; pressing
 * again removes it. `aria-pressed` and the check carry the state, never colour alone.
 */
export function CarQuickAddButton({ vehicle }: { vehicle: VehicleListing }) {
  const { added, blocked, shortLabel, toggle } = useCarOrderEntry(vehicle);

  return (
    <MediaIconButton
      label={`${shortLabel}: ${vehicleTitle(vehicle)}`}
      icon={added ? <Check /> : <AddShoppingCart />}
      tone={added ? 'active' : 'neutral'}
      onClick={toggle}
      disabled={blocked}
      aria-pressed={added}
    />
  );
}
